module.exports = __webpack_public_path__ + "img/Younger.1f777494.svg";